<script setup lang="ts">
    import { useCtUploadViewModel } from '@/views/case-settings/upload/ct/useCtUploadViewModel';

    const upload = useCtUploadViewModel();
</script>

<template>
    <app-form-group v-if="upload.hasScan" label="DICOM Series">
        <app-text-input disabled class="mt-2" model-value="The DICOM study has been uploaded" />
    </app-form-group>

    <app-form-group v-if="upload.hasScan" label="Series">
        <app-text-input
            disabled
            class="mt-2"
            data-testid="study-dicom-series"
            :model-value="upload.getStudy?.series"
        />
    </app-form-group>

    <app-form-group v-if="upload.hasScan" label="Files">
        <app-text-input
            disabled
            class="mt-2"
            data-testid="study-dicom-file-count"
            :model-value="upload.getStudy?.fileCount"
        />
    </app-form-group>
</template>
